import styled from 'styled-components';

export const Conteudo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding-top: 16px;
`;

export const Instrucoes = styled.div`
  font-size: 13px;
  color: #4a5568;
  line-height: 1.5;

  strong {
    color: #2d3748;
  }
`;

export const AreaArquivo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px;
  border: 2px dashed ${(props) => (props.$arrastando ? '#2670d1' : '#cbd5e0')};
  background: ${(props) => (props.$arrastando ? '#ebf8ff' : '#ffffff')};
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    border-color: #2670d1;
  }
`;

export const AreaTexto = styled.span`
  font-size: 13px;
  color: #718096;
`;

export const ArquivoLinha = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
`;

export const ArquivoNome = styled.span`
  flex: 1;
  min-width: 0;
  font-size: 14px;
  color: #2d3748;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ArquivoTamanho = styled.span`
  font-size: 12px;
  color: #718096;
  white-space: nowrap;
`;

export const Resumo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 12px;
  border-radius: 6px;
  border-left: 4px solid ${(props) => (props.$gravado ? '#34C759' : '#FF3B30')};
  background: ${(props) => (props.$gravado ? '#F0FFF4' : '#FFF5F5')};
`;

export const ResumoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ResumoLabel = styled.span`
  font-size: 11px;
  text-transform: uppercase;
  color: #718096;
`;

export const ResumoValor = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
`;

// Cada bloco de ocorrencia rola sozinho: arquivo grande pode devolver dezenas
// de linhas e o modal nao pode crescer sem fim.
export const Bloco = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 22vh;
  overflow-y: auto;
`;

export const BlocoTitulo = styled.span`
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 600;
  color: ${(props) => props.color || '#718096'};
`;

export const Item = styled.span`
  font-size: 13px;
  color: #4a5568;
  line-height: 1.4;
`;

export const Acoes = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding-top: 8px;
  border-top: 1px solid #e2e8f0;
`;
